import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('PaymentMethodService', PaymentMethodService);

  PaymentMethodService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'SessionService',
    'TranslationModalService',
    'WindowModalService',
  ];

  function PaymentMethodService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    SessionService,
    TranslationModalService,
    WindowModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'companies';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getPaymentMethods: getPaymentMethods,
      getPaymentMethod: getPaymentMethod,
      savePaymentMethod: savePaymentMethod,
      openPaymentMethodModal: openPaymentMethodModal,
      openPaymentMethodTranslations: openPaymentMethodTranslations,
      changePaymentMethodStatus: changePaymentMethodStatus,
      deletePaymentMethod: deletePaymentMethod,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filter = {
        page: 1,
        sortDir: 'asc',
        sortedBy: 'name',
      };

      return filter;
    }

    function getPaymentMethods(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      var url = apiUrl + '/' + SessionService.getSelectedAccountCompany().id + '/payment_methods';

      return RestResource.request(
        'get',
        url,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getPaymentMethod(id, language, translate) {
      var params;
      if (language) {
        params = {
          lang: language,
        };
      }

      if (translate) {
        params.get = 'translate';
      }

      var url = apiUrl + '/' + SessionService.getSelectedAccountCompany().id + '/payment_methods';

      return RestResource.request(
        'get',
        url + '/' + id,
        params,
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }

    function savePaymentMethod(paymentMethod, language) {
      var url = apiUrl + '/' + SessionService.getSelectedAccountCompany().id + '/payment_methods';
      var method = 'post';

      if (paymentMethod.id) {
        // edit
        url += '/' + paymentMethod.id;
        method = 'put';
      }

      var lang = language ? language : config.DEFAULT_CONTENT_LANGUAGE;

      function success(response) {
        var msg = !paymentMethod.id ? 'PAYMENT_METHOD_CREATED' : 'PAYMENT_METHOD_MODIFIED';
        utils._successMsg($translate(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(
        method,
        url,
        { payment_method: paymentMethod, lang: lang },
        success,
        failure
      );
    }

    function openPaymentMethodModal(
      paymentMethod,
      defaultLanguage,
      additionalLanguages,
      mode,
      successCallback
    ) {
      var templateUrl = './app/ajs/payment-methods/modals/payment-method-detail-modal.html';

      var originalItem = angular.copy(paymentMethod);

      var modalParams = {
        title: !paymentMethod.id ? 'CREATE_PAYMENT_METHOD' : 'PAYMENT_METHOD_DETAILS',
        item: originalItem,
        mode: mode,
        defaultLanguage: defaultLanguage,
        additionalLanguages: additionalLanguages,
        preventModalClose: true,
      };

      var confirmCallback = function (response) {
        if (paymentMethod.id) {
          // Edit
          paymentMethod.name = response.name;
          paymentMethod.incoming = response.incoming;
          paymentMethod.outgoing = response.outgoing;
          paymentMethod.requires_reference_number = response.requires_reference_number;

          return utils.itemListChanged(response.id);
        }

        return successCallback(response);
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }

    function openPaymentMethodTranslations(paymentMethod, additionalLanguages) {
      var template = './app/ajs/payment-methods/modals/payment-method-detail-translation.html';

      var modalParams = {
        title: paymentMethod.name,
        item: paymentMethod,
        additionalLanguages: additionalLanguages,
      };

      var initializeCallback = function (itemId, language) {
        return getPaymentMethod(itemId, language, 'translate').then(function (data) {
          return data;
        });
      };

      var confirmCallback = function (paymentMethod, language) {
        return savePaymentMethod(paymentMethod, language).then(function (data) {
          if (!data.status) {
            return data.response;
          }

          return false;
        });
      };

      TranslationModalService.open(template, modalParams, initializeCallback, confirmCallback);
    }

    function changePaymentMethodStatus(paymentMethod) {
      var url =
        apiUrl +
        '/' +
        SessionService.getSelectedAccountCompany().id +
        '/payment_methods/' +
        paymentMethod.id;

      utils.changeItemStatus(url, paymentMethod);
    }

    function deletePaymentMethod(paymentMethod, successCallback) {
      let url =
        apiUrl +
        '/' +
        SessionService.getSelectedAccountCompany().id +
        '/payment_methods/' +
        paymentMethod.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        {},
        function () {
          let params = {
            title: 'DELETE_PAYMENT_METHOD',
            itemName: paymentMethod.name,
            reason: 'DELETE_ITEM_REASON', // status is boolean - no way to record reason_status
            confirmButtonLabel: 'DELETE_PAYMENT_METHOD',
            successMsg: 'PAYMENT_METHOD_DELETED',
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }
  }
})();
